import { MatchesV2Schema } from '@/views/sports/Matches/styles/MatchesV2.styles';

export const matchesV2Styles: MatchesV2Schema = {
  pageHeaderText: {
    fontSize: 'md',
    fontWeight: 'medium',
  },
  mainBoxWrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  navOverride: {
    mb: '2',
  },
  divider: {
    mb: '3',
    opacity: '1',
    borderColor: '#c2c2c2',
  },
};
